export default __webpack_public_path__ + "static/floor-plan-1AR-e92c790a7c3c21ddcb997e5ff43edae8.pdf";